import { ProductCardGtmEvents } from '@/gtm/product/product-card-gtm-events';
import { ProductReviewsGtmEvents } from '@/gtm/product/product-reviews-gtm-events';
import { ProductQuickViewGtmEvents } from '@/gtm/product/product-quick-view-gtm-events';
import { ProductRecommendationGtmEvents } from '@/gtm/product/product-recommendation-gtm-events';
import { ProductRecentlyViewedGtmEvents } from '@/gtm/product/product-recently-viewed-gtm-events';
import { ProductAvailabilityGtmEvents } from '@/gtm/product/product-availability-gtm-events';

export const productGtmEvents = {
  card: new ProductCardGtmEvents(),
  quickView: new ProductQuickViewGtmEvents(),
  reviews: new ProductReviewsGtmEvents(),
  recommendations: new ProductRecommendationGtmEvents(),
  recentlyViewed: new ProductRecentlyViewedGtmEvents(),
  availability: new ProductAvailabilityGtmEvents(),
};
